/*@ngInject*/
const BaseGridWidgetController = function ($controller, $scope, $state, $stateParams, $rootScope,
                                           $uibModal, $window, advancedFilterMediator,
                                           advancedFilterModel, appTypeConfigurationModel, browserUtil,
                                           coreConstant, coreMediator, filterRepository,
                                           submissionGridConstant, gridColumnModel, localization,
                                           loadingBarHandler, persistentConnection, preferenceModel,
                                           submissionStateMediator, uiPerformanceLoggerConstant,
                                           currencyUtil, filterType, currentUserModel) {


    angular.extend(this, $controller('baseWidgetController', {$scope: $scope}));

  this.colResizable = false;
    this.isUserTypeUpdated = false;
    this.openFilter;
    this.columnPreference;
    this.shortDateFormat = null;
    this.isLoading = true;
    this.selectedFilterName = '';
    this.isGridEmpty = true;
    this.toolTipDelay = 500;
    this.totalRecords = 0;
    this.savedTotalRecords = 0;
    this.records = [];
    this.dropdownColumns = [];
    this.filters = {};
    this.colViewModel = {};
    this.isAgent = appTypeConfigurationModel.isAgentConsole();
    this.isDrawerOpen = false;
    this.isColSelectDropdownOpen = false;
    this.requestParams;
    this.uiPerformanceLogAction = '';
    this.gridLoadedEvent = '';
    this.isBulkUpdateMode = false;
    this.bulkUpdateSelectAll = false;
    this.isLoaded = false;
    this.selectedBulkItems = [];

    this.onInitGridWidget = function () {
        this.requestParams = this.getFilterParams();
        this.onInit();
    };

    this.getSelectedFilterName = function () {

    };

    this.loadGrid = function () {
        if (!this.isUserTypeUpdated || this.requestParams.criteriaName === '') {
            return;
        }
        this.isLoading = true;
        this.selectedFilterName = this.getSelectedFilterName();

        function onSuccess(result) {
            let resultRecords = result.records ? result.records : result,
                currencyCode;
            this.isLoading = false;
            this.isLoaded = true;
            this.records = _.map(resultRecords, function (record) {
                currencyCode = record.currencyCode || null;
                record.currencyFormat = currencyUtil.getCurrencyFormat(currencyCode);
                return record;
            });
            /*
             * If the server returns totalRecords as -1, that means that
             * the client should use the previous totalRecords value.
             */
            if (result.totalRecords === -1) {
                // this.savedTotalRecords is not reliable if we come back to a nont startIndex==0 page
                if (this.savedTotalRecords>0 || this.savedTotalRecords===0 && this.requestParams.startIndex===0) {
                  result.totalRecords = this.savedTotalRecords;
                }
                else if (currentUserModel.filterInfoMap && currentUserModel.filterInfoMap[this.selectedFilterName]) {
                  result.totalRecords = currentUserModel.filterInfoMap[this.selectedFilterName].totalRecords;
                }
            }
            // filter-level config and paging info is only supported for submissionGrid now
            else if (this.advancedFilterType==='submissionGrid' && currentUserModel.filterInfoMap && currentUserModel.filterInfoMap[this.selectedFilterName]) {
                currentUserModel.filterInfoMap[this.selectedFilterName].totalRecords = result.totalRecords;
            }
            this.totalRecords = result.totalRecords || resultRecords.length;
            if (this.totalRecords >= 0) {
              this.savedTotalRecords = this.totalRecords;
            }
            this.showPaging = this.totalRecords > this.requestParams.pageSize;
            this.isGridEmpty = this.records.length === 0;
            this.recalculateGridPaging();

            $rootScope.$broadcast(this.gridLoadedEvent);
            // just pass the column config to the landingController without saving it
            this.notifyColumnsChange(null, false);

            coreMediator.loadUserProfile().then(function (userProfile) {
                this.userId = userProfile.userId;
                localization.getTranslationByKey(appTypeConfigurationModel.getConsoleTitleKey()).then(function (translation) {
                    let action = uiPerformanceLoggerConstant.LOGIN,
                        status = coreConstant.uiPeformanceLogger.SUCCESS,
                        message = $window.location.href;
                    message += '|' + $window.navigator.userAgent;
                    message += '|' + browserUtil.getOSName();
                    message += '|' + translation;
                    message += '|' + appTypeConfigurationModel.getUserType();
                    message += '|' + userProfile.userName;
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status, message);
                });
            }.bind(this));

            let filterAction = this.uiPerformanceLogAction + ':' + this.getSelectedFilterName(),
                status = coreConstant.uiPeformanceLogger.SUCCESS;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, filterAction, status);
        }

        function onError() {
            let filterAction = this.uiPerformanceLogAction + ':' + this.getSelectedFilterName(),
                status = coreConstant.uiPeformanceLogger.FAIL;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, filterAction, status);
        }

        return this.loadRecords(onSuccess.bind(this), onError.bind(this));
    };

    this.loadListOnFilterChange = function () {
        this.openFilter = null;
        this.calculateFilterParams();
        this.resetGridPaging();
        this.loadGrid();
    };

    this.resetGridPaging = function () {
        $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    };

    this.recalculateGridPaging = function () {
        $scope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
    };

    this.resetGridColumns = function () {
        this.updateColumnsFromPreferences();  // update the columnPreference in shared gridColumnModel
        this.generateColumns();
        this.loadGrid();
    };

    this.initLandingPage = function () {
        this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        this.updateDefaultSortColumn();
        this.updateColumnsFromPreferences();
        this.resetGridColumns();
        this.updateFilterFromPreferences();
    };

    this.loadRecords = function (onSuccess, onError) {
        if(this.advancedFilterType === 'submissionGrid') {
            this.requestParams = this.getFilterParams();
        }

        if (this.requestParams.filterUri !== '') {
            this.loadRecordsInt(this.requestParams).then(onSuccess, onError).finally(function () {
                this.updateBulkUpdateSelectAllState();
                this.updateSelectedBulkItems();
            }.bind(this));
        }
    };

    this.loadRecordsInt = function () {

    };

    this.updateDefaultSortColumn = function () {

    };

    this.resetFilter = function () {
        let filterName = this.getSelectedFilterName(),
            selectedFilter = _.find(this.filters, ['name', filterName]),
            isOpen = this.isSearchOpen;
        this.onFilterChange(selectedFilter);
        this.isSearchOpen = isOpen;
    };

    this.getFilterStatus = function () {
        if(this.isFilterEdited()) {
            return this.i18n.advancedFilter.editedFilter;
        } else {
            return '';
        }
    };

    this.isFilterEdited = function () {
        let filterUri = !_.isNil(this.getOpenFilterUri()) ? this.getOpenFilterUri() : gridColumnModel.getSavedFilterUri(this.advancedFilterType),
            hasFilterBeenUpdated = !_.isNil(filterUri) && !_.isNaN(filterUri),
            isCurrentFilterTemporary = _.isNil(_.find(this.filters, ['uri', filterUri]));
        return hasFilterBeenUpdated && isCurrentFilterTemporary;
    };

    this.isFilterTemporary = function () {
        let filterUri = !_.isNil(this.getOpenFilterUri()) ? this.getOpenFilterUri() : gridColumnModel.getSavedFilterUri(this.advancedFilterType),
            isCurrentFilterTemporary = _.isNil(_.find(this.filters, ['uri', filterUri]));
        return isCurrentFilterTemporary;
    };

    this.isDefaultFilter = function () {
        let filter = _.find(this.filters, ['name', this.selectedFilterName]);
        return !_.isNil(filter) && !_.isNil(filter.uri) && filter.uri.startsWith('com.firstbest.underwriting.filter.DefaultFilter') ;
    };

    this.updateFilterFromPreferences = function () {
    // savedFilterUri is the last filter that was used for the grid.
    // It's remembered in gridColumnModel so that when we come back to the grid from the submission screen, we know the right filter to use
    let savedFilterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);
        filterRepository.getFilters().then(function (filters) {
            this.filters = _.filter(filters, {'type': this.filterType, 'temporary': false});
            if (!savedFilterUri) {
              this.selectedFilterName = _.get(_.first(this.filters), 'name');
              this.setSelectedFilterName(this.selectedFilterName);
              $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
      }
      else {
              filterRepository.getFilter(savedFilterUri).then(function (filter) {
          if (filter) {
            this.selectedFilterName = filter.name;
                    this.setSelectedFilterName(this.selectedFilterName);
                  $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
          }
        }.bind(this));
      }
        }.bind(this));
    };

    this.updateFilterFromUserPreferences = function (type, filterUri) {
        if (type===filterType.TYPE_SUBMISSION_FILTER) {
          let prefName = "views.submissionGrid:"+filterUri;
          let sortType = gridColumnModel.getWidgetConfig(prefName, 'sortType');
          let sortKey = gridColumnModel.getWidgetConfig(prefName, 'sortKey');
          if (sortType) {
              gridColumnModel.updateSubmissionParamByName('sortType', sortType);
              gridColumnModel.updateSubmissionParamByName('key', sortKey);
          }
        }
    }

    this.calculateFilterParams = function () {

        let filterParams,
            filter,
            savedFilterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);

        if (!_.isNaN(savedFilterUri) && !_.isNil(savedFilterUri)) {
            filterParams = this.getFilterParams();
            filterParams.filterUri = savedFilterUri;
            this.setFilterParams(filterParams);

            filterRepository.getFilter(gridColumnModel.getSavedFilterUri(this.advancedFilterType)).then(function (filter) {
                this.selectedFilterName = filter.name;
                this.setSelectedFilterName(filter.name);

                if (!_.isNil(filter)) {
                    advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
                        advancedFilterModel.buildFilter(this.advancedFilterType, filterTemplate, filter);
                        this.filterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
                    }.bind(this));

                    this.updateFilterFromUserPreferences(filter.type, filterParams.filterUri);

                    this.isSearchOpen = this.isFilterEdited();
                    if (!_.isNil(this.getOpenFilterUri())) {
                        this.isSearchOpen = true;
                        this.isDrawerOpen = true;
                    }
                }
            }.bind(this));

        } else {
            this.selectedFilterName = this.getSelectedFilterName();
            filterParams = this.getFilterParams();
            filter = _.find(this.filters, ['name', this.selectedFilterName]);

            if (!_.isNil(this.openFilter)) {
                filter = this.openFilter;
            }

            if (!_.isNil(filter)) {
                advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
                    advancedFilterModel.buildFilter(this.advancedFilterType, filterTemplate, filter);
                    this.filterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
                }.bind(this));
                if (_.isNil(this.openFilter)) {
                    this.setOpenFilterUri(null);
                } else {
                    this.setOpenFilterUri(this.openFilter.uri);
                }

                if (this.openFilter) {
                    this.isSearchOpen = true;
                    filterParams.filterUri = this.openFilter.uri;
                } else {
                    this.isSearchOpen = false;
                    filterParams.filterUri = filter.uri;
                    this.setFilterParams(filterParams);
                }

                this.updateFilterFromUserPreferences(filter.type, filterParams.filterUri);

                if(this.alwaysShowSearch) {
                    this.isSearchOpen = true;
                }
            }
        }
    };

    this.setFilterParams = function (filterParams) {

    };

    this.getFilterParams = function () {

    };

    this.resetParams = function (params) {

    };

    this.setOpenFilterUri = function (filterUri) {
    };

    this.getOpenFilterUri = function () {
    };

    this.resetGridHeaders = function (params) {
        this.resetParams(params);
        this.loadGrid();
        $rootScope.$broadcast(coreConstant.event.GRID_SORT_TYPE_CHANGED, params, this.advancedFilterType);
    };

    this.generateColumns = function () {

    };

    this.updateColumnsFromPreferences = function () {
        // this is legacy -- not good to share gridColumnModel.columnPreference across widgets
        gridColumnModel.setColumnPreference(this.columnPreference);
    };

    this.onStartResize = function () {
      this.colResizable = true;
    };
    this.onFinishResize = function () {
      this.colResizable = false;
    };

    this.onFilterChange = function (filter) {
        this.updateColumnsFromPreferences();  // update the columnPreference in shared gridColumnModel
        // reset filter first
        gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
        currentUserModel.filterInfoMap[filter.name] = {};
        if (filter) {
          // remember the open filter
            if (this.isSearchOpen) {
            this.setOpenFilterUri(filter.uri);
          }
          gridColumnModel.setSavedFilterUri(this.advancedFilterType, filter.uri);
        }
        gridColumnModel.setSavedSortType(this.advancedFilterType, null);
        let action = this.uiPerformanceLogAction + ':' + filter.name;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, null);
        this.setSelectedFilterName(filter.name, true);
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
        $rootScope.$broadcast(coreConstant.event.FILTER_CHANGED, filter.uri, this.advancedFilterType);
    };

    // Intended to be overwritten by a controller extending this
    this.isMultiSelectMode = function () {
        return false;
    };

    this.openSubmission = _.debounce(function (submissionId) {
        let params = {submissionId: submissionId},
            stateName = 'submission.default';

        if(!this.isMultiSelectMode()) {
            if (submissionId === parseInt($stateParams.submissionId)) {
                return;
            }

            if (this.isColSelectDropdownOpen) {
                this.updateDropdownClosed();
                return;
            }

            if (!this.isSearchOpen) {
                this.setOpenFilterUri(null);
            }

            this.isLoading = true;
            $state.go(stateName, params);
        }
    }.bind(this), 200, {leading: true});

    this.setSelectedItem = function (event, selectedItem) {
        if(!this.isMultiSelectMode()) {
            if (this.isBulkUpdateMode) {
                this.handleBulkUpdateRowClick(selectedItem);
            }
            else {
                if (selectedItem.selected) {
                    selectedItem.selected = false;
                    this.isDrawerOpen = false;
                    return;
                }

                if ($(event.currentTarget).hasClass('toggleDrawer')) {
                    this.isDrawerOpen = true;
                }

                _.forEach(this.records, function (item) {
                    item.selected = (item === selectedItem);
                });

                $scope.$broadcast(this.openDetailDrawerEvent);
            }
        }
    };

    this.updateDropdownClosed = function () {
        this.isColSelectDropdownOpen = false;
    };

    this.getFilterPrefName = function (filterUri) {
        return null;
    };

    this.onColumnCheckboxClick = function (event, column) {
        if (!column.disabled) {
            column.visible = !column.visible;
            this.updateColumnsFromPreferences();
            let columnsXML = gridColumnModel.getGridColumnXML(column, this.getFilterPrefName());
            this.notifyColumnsChange(columnsXML);
        }

        event.preventDefault();
        event.stopPropagation();
    };

    this.notifyColumnsChange = function (columnsXML, doSave=true) {
        this.updateColumnsFromPreferences();
        if (!columnsXML) {
            columnsXML = gridColumnModel.getGridColumnXML(null, this.getFilterPrefName());
        }
        if (doSave && (this.columnPreference === 'system.accountSubmissionsGridColumns' ||
                 this.columnPreference === 'system.accountOverviewSubmissionColumnsForAgent' ||
                 this.columnPreference === 'system.accountOverviewSubmissionColumnsForUnderwriter') )
        {
            coreMediator.updateUserPreferences(this.columnPreference, columnsXML).then(function () {
                    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS);
                });
        } else {
            $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, columnsXML, doSave);
        }
    }

    this.cancelClickEvent = function (event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    };

    this.handleFilterSave = function (event, filter) {
        this.updateColumnsFromPreferences();  // update the columnPreference in shared gridColumnModel
        // get the columns XML for the current filter
        let columnsXML = gridColumnModel.getGridColumnXML(null, this.getFilterPrefName());

        let filterParams = this.getFilterParams(),
            selectedFilter = _.find(this.filters, ['name', this.selectedFilterName]);

        if (selectedFilter.name === filter.name) {
            filterParams.filterUri = filter.uri;
            filterParams.startIndex = 0;
            this.setFilterParams(filterParams);
            this.resetGridPaging(filterParams.pageSize, filterParams.startIndex);
            $rootScope.$broadcast(coreConstant.event.FILTER_CHANGED, filter.uri, this.advancedFilterType);
        }

        gridColumnModel.setSavedFilterUri(this.advancedFilterType, filter.uri);
        if (this.isSearchOpen) {
            this.setOpenFilterUri(filter.uri);
        }

        // update the column config in landingController
        this.notifyColumnsChange(columnsXML);
    };

    this.onToggleSearch = function () {
        this.isSearchOpen = !this.isSearchOpen;
    };

    this.onSaveFilterAs = function () {
        let modalInstance = $uibModal.open({
            templateUrl: '/ui/advancedFilter/saveAs/saveFilterAsModal.tpl.html',
            controller: 'saveFilterAsModalController',
            backdrop: 'static',
            windowClass: 'saveFilterAsModal',
            resolve: {
                filters: function () {
                    return _.filter(this.filters, {'type': this.filterType, 'temporary': false})
                }.bind(this)
            }
        });
        modalInstance.result.then(function (response) {

            function onSuccess(result) {
                filterRepository.getFilters().then(function (filters) {
                    gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
                    this.filters = _.filter(filters, {'type': this.filterType, 'temporary': false});
                    this.setSelectedFilterName(result.name);
                    this.selectedFilterName = result.name;
                    this.handleFilterSave(coreConstant.event.FILTER_SAVED, result);
                    this.calculateFilterParams();
                    loadingBarHandler.hideLoadingBar();
                }.bind(this));
            }

            let currentFilter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
            currentFilter.id = null;
            currentFilter.uri = null;
            currentFilter.name = response.filterName;
            currentFilter.temporary = false;
            currentFilter.userId = this.userId;
            loadingBarHandler.showLoadingBar('advancedFilter.saveFilterAs.loadingBar');
            advancedFilterMediator.saveFilter(currentFilter).then(onSuccess.bind(this));
        }.bind(this));
    };

    this.onDeleteFilter = function () {
        let currentFilter = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter;

        function onSuccess() {
            filterRepository.getFilters().then(function (filters) {
                gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
                this.filters = _.filter(filters, {'type': this.filterType, 'temporary': false});
                this.onFilterChange(_.first(this.filters));
                loadingBarHandler.hideLoadingBar();
            }.bind(this));
        }

        function deleteFilter() {
            loadingBarHandler.showLoadingBar('advancedFilter.deleteFilter.loadingBar');
            advancedFilterMediator.deleteFilter(currentFilter).then(onSuccess.bind(this));
        }

        localization.getTranslationByKey('advancedFilter.deleteFilter').then(function (translation) {
            let options = {
                title: _.get(translation, 'title'),
                summary: _.get(translation, 'summary'),
                cancelButtonLabel: _.get(translation, 'cancelButton'),
                confirmActionButtonLabel: _.get(translation, 'deleteButton')
            };

            let modalInstance = $uibModal.open({
                templateUrl: '/ui/modal/modal.tpl.html',
                controller: 'modalController',
                backdrop: 'static',
                windowClass: 'genericModal',
                resolve: {
                    options: function () {
                        return options;
                    }
                }
            });
            modalInstance.result.then(deleteFilter.bind(this));
        }.bind(this));
    };

    this.setSelectedFilterName = function (filterName) {

    };

    this.onSaveFilter = function () {
        let currentFilter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);

        function onSuccess(result) {
            filterRepository.getFilters().then(function (filters) {
                gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
                this.filters = _.filter(filters, {'type': this.filterType, 'temporary': false});
                this.setSelectedFilterName(result.name);
                this.handleFilterSave(coreConstant.event.FILTER_SAVED, result);
                loadingBarHandler.hideLoadingBar();
            }.bind(this));
        }

        currentFilter.uri = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter.uri;
        currentFilter.name = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter.name;
        currentFilter.temporary = false;
        currentFilter.userId = this.userId;
        loadingBarHandler.showLoadingBar('advancedFilter.saveFilterAs.loadingBar');
        advancedFilterMediator.saveFilter(currentFilter).then(onSuccess.bind(this));
    };

    this.handleBulkUpdateRowClick = function (selectedItem) {
        selectedItem.selected = !selectedItem.selected;

        this.updateSelectedBulkItems();
        this.updateBulkUpdateSelectAllState();
    };

    this.updateSelectedBulkItems = function () {
        this.selectedBulkItems = _.filter(this.records, function (record) {
            return record.selected;
        });
    };

    this.updateBulkUpdateSelectAllState = function () {
        this.bulkUpdateSelectAll = this.selectedBulkItems.length === this.records.length;
    };

    this.onBulkUpdate = function () {
        this.isBulkUpdateMode = true;
        this.selectedBulkItems = [];
    };

    this.onCancelBulkUpdate = function () {
        this.isBulkUpdateMode = false;
        this.bulkUpdateSelectAll = false;

        _.map(this.records, function (record) {
            record.selected = false;
        }.bind(this));
    };

    this.onBulkUpdateSelectAllRecords = function () {
        _.map(this.records, function (record) {
            record.selected = this.bulkUpdateSelectAll;
        }.bind(this));

        this.updateSelectedBulkItems();
    };

    this.isPastDue = function (dueDate) {
        return moment(dueDate).isBefore(moment.utc(new Date()));
    };

    this.rearrangeColumn = function(columns, columnToRearrange, targetColumn, isLeftDrop) {
        let toRearrange = _.find(columns, function (c) {
            return c.__text === columnToRearrange;
        });
        let target = _.find(columns, function (c) {
            return c.__text === targetColumn;
        });
        if (toRearrange && target) {
      let index = columns.indexOf(toRearrange);
      columns.splice(index, 1);
      let targetIndex = columns.indexOf(target);
      if (!isLeftDrop) {
        targetIndex += 1;
      }
      columns.splice(targetIndex, 0, toRearrange);
    }
        let value = gridColumnModel.getColumnsXML(columns);
    $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, value);
  };

  this.resizeColumn = function(columns, columnIdentifier, newWidth) {
        let column = _.find(columns, function (c) {
            return c.__text === columnIdentifier;
        });
        column._width = newWidth;
        let value = gridColumnModel.getColumnsXML(columns);
    $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, value);
    };


};

angular.module('umCore')
    .controller('baseGridWidgetController', BaseGridWidgetController);
